// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__1PfPO","actionsCol":"EnrolledClinics_actionsCol__xwaH_"};